import { render, staticRenderFns } from "./ModeratorsIndex.vue?vue&type=template&id=2e889248"
import script from "./ModeratorsIndex.vue?vue&type=script&lang=js"
export * from "./ModeratorsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports